import { Box } from '@mui/material';
import { Fragment, useMemo } from 'react';
import { COLOUR, tokenise } from './xmlTokens';

/** One line of XML: gutter, optional diff marker, and syntax-coloured tokens. */
export function XmlLine({
  text,
  lineNumber,
  gutterWidth,
  marker,
}: {
  text: string;
  /** Absent for a line that has no place in the original document, e.g. an added diff line. */
  lineNumber?: number;
  gutterWidth: number;
  /** The diff operation character, when this line is part of a diff. */
  marker?: string;
}) {
  const tokens = useMemo(() => tokenise(text), [text]);

  return (
    <Box component="span" sx={{ display: 'block' }}>
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          width: `${gutterWidth}ch`,
          pr: 1.5,
          textAlign: 'right',
          color: 'text.disabled',
          // The gutter must not be picked up by a copy of the document.
          userSelect: 'none',
        }}
      >
        {lineNumber ?? ''}
      </Box>
      {marker !== undefined && (
        <Box
          component="span"
          sx={{ display: 'inline-block', width: '2ch', userSelect: 'none' }}
        >
          {marker}
        </Box>
      )}
      {tokens.map((token, index) => (
        <Fragment key={index}>
          <Box component="span" sx={{ color: COLOUR[token.kind] }}>
            {token.text}
          </Box>
        </Fragment>
      ))}
    </Box>
  );
}

export default XmlLine;
